export default {
    LOAD_WEATHER_APP(state, weather) {
        state.items = weather
    }
}